import { memo, type RefObject, useLayoutEffect, useRef } from "react";

import useAppSelector from "../utils/hooks/useAppSelector";

function PlatformInfoFocusListener({
  platformInfoRef,
}: {
  platformInfoRef: RefObject<HTMLDivElement | null>;
}) {
  const areSituationsOpen = useAppSelector((state) => state.areSituationsOpen);
  const previousAreSituationsOpenRef = useRef(areSituationsOpen);

  useLayoutEffect(() => {
    if (previousAreSituationsOpenRef.current === areSituationsOpen) {
      return;
    }
    previousAreSituationsOpenRef.current = areSituationsOpen;

    let cancelled = false;
    queueMicrotask(() => {
      if (!cancelled) {
        platformInfoRef.current?.focus({ preventScroll: true });
      }
    });

    return () => {
      cancelled = true;
    };
  }, [areSituationsOpen, platformInfoRef]);

  return null;
}

export default memo(PlatformInfoFocusListener);
